<template>
  <li class="nav-item nav-toplevel" @click="animateNotificationIcon = false">
    <router-link class="nav-top-link radial-hover" :to="inboxPageLocation"
      ><i
        class="bell-icon flex-shrink-0"
        :class="{ 'ring-animate': animateNotificationIcon }"
        @animationend="animateNotificationIcon = false"
      ></i>
      <div class="d-flex justify-content-between align-items-center flex-grow-1">
        <span>Inbox</span
        ><span class="notification-count text-small-1" v-if="notificationCount">{{
          notificationCount
        }}</span>
      </div>
    </router-link>
    <new-notification-tooltip :org-id="orgId" v-if="!newNotificationTooltipDismissed" />
  </li>
</template>

<script>
import NewNotificationTooltip from '@/components/notifications/NewNotificationTooltip'
import { ROUTE_NAMES } from '@/constants/routes'
import { STORAGE_KEYS } from '@/constants/storage'
import { getInboxPageRouteConfig } from '@/utils/navigationConfigs'
import * as R from 'ramda'

/**
 * This is the link for Inbox page, which is shown in the sidebar navigation.
 */
export default {
  name: 'InboxLink',
  props: ['orgId'],
  components: {
    NewNotificationTooltip
  },
  data() {
    return {
      newNotificationTooltipDismissed:
        localStorage.getItem(STORAGE_KEYS.newNotificationTooltipDismissed) === 'true',
      animateNotificationIcon: false
    }
  },
  computed: {
    inboxPageLocation() {
      return getInboxPageRouteConfig(this.orgId)
    },
    notificationSummary() {
      return R.pathOr(
        {},
        ['notificationCenter', this.orgId, 'summary'],
        this.$store.state.notification
      )
    },
    notificationCount() {
      return R.prop('count', this.notificationSummary)
    }
  },
  methods: {},
  mounted() {},
  watch: {
    notificationCount(current, previous) {
      if (current > (previous ?? 0) && this.$route.name !== ROUTE_NAMES.INBOX) {
        this.animateNotificationIcon = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
@import '~@/styles/animations/_ring.scss';
@import '~@/styles/_hoverStates.scss';

.bell-icon {
  @include dimension(15px, 15px);
}

.notification-count {
  border-radius: 15px;
  min-width: 20px;
  text-align: center;
  background-color: $error;
  color: $documentColor;
  align-self: center;
  padding: 0 6px;
}
</style>
